import secureLocalStorage from "react-secure-storage";
import * as React from "react";
import Images from "../../Assets/Images";
import Api from "../../Services/Api";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Checkbox } from "@progress/kendo-react-inputs";
import { Popup } from "@progress/kendo-react-popup";
import { CircularProgress } from "@material-ui/core";
import { toastr } from "react-redux-toastr";
import * as moment from "moment";

export default class GenerateReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      impactWithCountCols: [],
      widgetTypeListTemp: [],
      widgetTypeList: [],
      widgetError: {
        widgetName: false,
        widgetChart: false,
        widgetDashboard: false,
        widgetDataSet: false,
        widgetXAxis: false,
        widgetYAxis: false,
      },
      dashboardList: [],
      datasourceList: [],
      isNameExist: false,
      timestampXAxisColumns: [],
      IsTimestamp: false,
      trendYAxis: [],
      dateSelectionType:"manual", // Default to manual date selection
      lastNDays: 30, // Default value for last N days
    };
  }

  componentDidMount() {}

  ToggleTimestamp = (event) => {
    this.setState({ IsTimestamp: event.value });
    let chartList = [];
    if (this.state.viewFlag == "MITI") {
      chartList = this.state.widgetTypeListTemp.filter(
        (item) =>
          item.name !== "HEAT_MAP" &&
          item.name != "MONTE_CARLO" &&
          item.name != "KPI" &&
          item.name != "DATA" &&
          item.name != "TEXT_WIDGET" &&
          item.name != "TRENDING_CHART"
      );
      if (event.value) {
        this.setState({
          xAxisColumnsList: this.state.xAxisColumnsList,
          yAxisColumnsList: this.state.timestampYAxisColumns,
          XAxisValue: {},
          YAxisValue: {},
          IsTimestamp: event.value,
          widgetTypeList: chartList,
        });
      } else {
        this.setState({
          xAxisColumnsList: this.state.xAxisColumnsList,
          yAxisColumnsList: this.state.timestampYAxisColumns,
          XAxisValue: {},
          YAxisValue: {},
          IsTimestamp: event.value,
          widgetTypeList: this.state.widgetTypeListTemp,
        });
      }
    } else {
      let arr = this.state.timestampXAxisColumns.filter(
        (item) => item.type !== "CustomField"
      );

      chartList = this.state.widgetTypeListTemp.filter(
        (item) =>
          item.name !== "BURN_DOWN_CHART" &&
          item.name != "MONTE_CARLO" &&
          item.name != "KPI" &&
          item.name != "DATA" &&
          item.name != "TEXT_WIDGET" &&
          item.name != "TRENDING_CHART"
      );

      if (event.value) {
        this.setState({
          xAxisColumnsList: arr,
          yAxisColumnsList: this.state.timestampYAxisColumns,
          XAxisValue: {},
          YAxisValue: {},
          IsTimestamp: event.value,
          widgetTypeList: chartList,
        });
      } else {
        this.setState({
          xAxisColumnsList: arr,
          yAxisColumnsList: this.state.timestampYAxisColumns,
          XAxisValue: {},
          YAxisValue: {},
          IsTimestamp: event.value,
          widgetTypeList: this.state.widgetTypeListTemp,
        });
      }
    }
  };

  createWidgetdClose = () => {
    this.setState({
      widgetError: {
        widgetName: false,
        widgetChart: false,
        widgetDashboard: false,
        widgetDataSet: false,
        widgetXAxis: false,
        widgetYAxis: false,
      },
      // ActiveId: null,
      openWidgetCreatePopup: false,
      Name: "",
      title: "",
      description: "",
      dashboard: "",
      datasource: "",
      XAxisValue: "",
      YAxisValue: "",
      WidgetTypeId: "",
      ActiveId: "",
    });
  };
  //trigger from parent
  createWidgetdOpen = (viewFlag) => {
    this.getDataSource(viewFlag);
    this.getDashboard();
    this.getWidgets(viewFlag);
    this.setState({
      ...this.state,
      openWidgetCreatePopup: true,
      viewFlag: viewFlag,
      IsTimestamp: false,
      isOpportunities: false,
      widgetTypeList: this.props.widgetTypeList,
      startDate: "",
      endDate: "",
      isNameExist: false,
      widgetName: "",
      dateSelectionType:"manual",
      lastNDays: 30
    });
  };

  //trigger from parent
  editWidgetdOpen = async (viewFlag, data) => {
    this.state = { ...this.state, loader: true };
    await this.getDataSource(viewFlag);
    await this.getDashboard();
    await this.getWidgets(viewFlag);
    this.populateValues(data);
    this.setState({
      ...this.state,
      openWidgetCreatePopup: true,
      viewFlag: viewFlag,
      loader: false,
    });
  };

  populateValues = (data) => {
    var dashboard = this.state.dashboardList.filter(
      (item) => item.dashboardId == data.dashboardId
    );
    dashboard = dashboard.length > 0 ? dashboard[0] : [];
    var datasource = this.state.datasourceList.filter(
      (item) => data.dataSourceId == item.id
    );
    datasource = datasource.length > 0 ? datasource[0] : {};
    var xaxisList =
      data.widgetType == "HEAT_MAP" || data.widgetType == "MONTE_CARLO"
        ? this.state.heatmapCols
        : this.state.xAxisColumnsList;
    var xName = xaxisList.filter((item) => item.displayName == data.xName);
    xName = xName.length > 0 ? xName[0] : {};
    var yaxisList =
      data.widgetType != "HEAT_MAP" || data.widgetType != "MONTE_CARLO"
        ? this.state.yAxisColumnsList
        : [];
    var yName = yaxisList.filter((item) => item.displayName == data.yAxes);
    yName = yName.length > 0 ? yName[0] : {};
    var startDate = data.startDate ? new Date(data.startDate) : null;
    var endDate = data.endDate ? new Date(data.endDate) : null;

    this.state = {
      ...this.state,
      widgetId: data.widgetId,
      dashboard: dashboard,
      datasource: datasource,
      Name: data.widgetName,
      YAxisValue: yName,
      XAxisValue: xName,
      IsTimestamp: data.timeStamp,
      isOpportunities: data.isOpportunities,
      startDate: startDate, //new Date(startDate.setDate(startDate.getDate() - 1)),
      endDate: endDate, //new Date(endDate.setDate(endDate.getDate() - 1)),
      title: data.title,
      description: data.description,
      WidgetTypeId: data.widgetTypeId,
      ActiveId: data.widgetTypeId,
      widgetName: data.widgetType,
    };
  };

  getDashboard = async () => {
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      this.state = { ...this.state, loader: true };
      let response = await Api.getDashBoardList(request);
      if (response.status == 200 && response.dashboards) {
        this.setState({
          ...this.state,
          loader: false,
          dashboardList: response.dashboards,
        });
      } else {
        this.setState({
          ...this.state,
          loader: false,
          dashboardList: [],
        });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };

  getDataSource = async (viewFlag) => {
    try {
      let type;
      if (viewFlag === "MITI") {
        type = "Mitigation";
      } else if (viewFlag === "RISK") {
        type = "Risk";
      } else if (viewFlag === "TASK") {
        type = "Task";
      } else if (viewFlag === "ACTIVITIES") {
        type = "TaskAction";
      }
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        Type: type,
      };
      this.state = { ...this.state, loader: true };
      let response = {};
      if (viewFlag === "MITI") {
        response = await Api.getMitigationViewAxis(request);
      } else if (viewFlag === "RISK") {
        response = await Api.getView(request);
      } else if (viewFlag === "TASK") {
        response = await Api.getTaskDatasetList(request);
      } else if (viewFlag === "ACTIVITIES") {
        response = await Api.getTaskActionDatasetList(request);
      }

      if (response.status == 200) {
        const heatmapCols = response.yAxisColumns.filter(
          (task) =>
            task.colsName != "Frequency" && task.colsName != "MitigationCount"
        );
        this.setState({
          ...this.state,
          datasourceList: response.datasource,
          xAxisColumnsList: response.xAxisColumns,
          yAxisColumnsList: response.yAxisColumns,
          xAxisColumnsListTemp: response.xAxisColumns,
          yAxisColumnsListTemp: response.yAxisColumns,
          timestampXAxisColumns: response.timestampXAxisColumns,
          timestampYAxisColumns: response.timestampYAxisColumns,
          loader: false,
          heatmapCols: heatmapCols,
        });
      } else {
        this.setState({ ...this.state, data: [], loader: false });
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  getChatImage = (img) => {
    var chartImg = "";
    if (img === "BARCHART") {
      chartImg = Images.BARCHART;
    } else if (img === "TEXTWIDGET") {
      chartImg = Images.TEXT;
    } else if (img === "KPI") {
      chartImg = Images.VIEWLIST;
    } else if (img === "DOUGHNUTCHART") {
      chartImg = Images.DOUGHNUTCHART;
    } else if (img === "BUBBLECHART") {
      chartImg = Images.BUBBLECHART;
    } else if (img === "GAUGECHART") {
      chartImg = Images.GAUGECHART;
    } else if (img === "PIECHART") {
      chartImg = Images.PIECHART;
    } else if (img === "GRIDCHART") {
      chartImg = Images.GRIDCHART;
    } else if (img === "LINECHART") {
      chartImg = Images.LINECHART;
    } else if (img === "AREACHART") {
      chartImg = Images.AREACHART;
    } else if (img === "HEATMAP") {
      chartImg = Images.HEATMAP;
    } else if (img === "BURNDOWNCHART") {
      chartImg = Images.AREACHART;
    } else if (img === "HISTOGRAM") {
      chartImg = Images.DASHBOARDICON;
    } else if (img === "DATA") {
      chartImg = Images.VIEWDATA;
    } else if (img === "TRENDINGCHART") {
      chartImg = Images.GAUGECHART;
    }
    return chartImg;
  };

  handleValidationWidget = () => {
    let widgetValidationName = false;
    let widgetValidationDashboard = false;
    let widgetValidationType = false;
    let widgetValidationXAxis = false;
    let widgetValidationYAxis = false;
    let widgetValidationDatasource = false;
    if (this.state.Name && this.state.Name.trim() != "") {
      this.setState((prevState) => ({
        widgetError: {
          ...prevState.widgetError,
          widgetName: false,
        },
      }));
      widgetValidationName = false;
    } else {
      this.setState((prevState) => ({
        widgetError: {
          ...prevState.widgetError,
          widgetName: true,
        },
      }));
      widgetValidationName = true;
    }
    if (this.state.dashboard) {
      this.setState((prevState) => ({
        widgetError: {
          ...prevState.widgetError,
          widgetDashboard: false,
        },
      }));
      widgetValidationDashboard = false;
    } else {
      this.setState((prevState) => ({
        widgetError: {
          ...prevState.widgetError,
          widgetDashboard: true,
        },
      }));
      widgetValidationDashboard = true;
    }
    if (this.state.WidgetTypeId) {
      this.setState((prevState) => ({
        widgetError: {
          ...prevState.widgetError,
          widgetChart: false,
        },
      }));
      widgetValidationType = false;
    } else {
      this.setState((prevState) => ({
        widgetError: {
          ...prevState.widgetError,
          widgetChart: true,
        },
      }));
      widgetValidationType = true;
    }
    if (this.state.widgetName !== "TEXT_WIDGET") {
      if (this.state.datasource && this.state.datasource.length !== 0) {
        this.setState((prevState) => ({
          widgetError: {
            ...prevState.widgetError,
            widgetDataSet: false,
          },
        }));
        widgetValidationDatasource = false;
      } else {
        if (
          this.state.widgetName !== "HEAT_MAP" &&
          this.state.widgetName != "MONTE_CARLO"
        ) {
          this.setState((prevState) => ({
            widgetError: {
              ...prevState.widgetError,
              widgetDataSet: true,
            },
          }));
          widgetValidationDatasource = true;
        }
      }
      if (
        this.state.widgetName !== "BURN_DOWN_CHART" &&
        this.state.widgetName !== "DATA" &&
        this.state.widgetName !== "KPI" &&
        this.state.widgetName !== "TRENDING_CHART"
      ) {
        if (
          this.state.XAxisValue &&
          Object.keys(this.state.XAxisValue).length !== 0
        ) {
          this.setState((prevState) => ({
            widgetError: {
              ...prevState.widgetError,
              widgetXAxis: false,
            },
          }));
          widgetValidationXAxis = false;
        } else {
          this.setState((prevState) => ({
            widgetError: {
              ...prevState.widgetError,
              widgetXAxis: true,
            },
          }));
          widgetValidationXAxis = true;
        }
        if (
          this.state.YAxisValue &&
          Object.keys(this.state.YAxisValue).length !== 0
        ) {
          this.setState((prevState) => ({
            widgetError: {
              ...prevState.widgetError,
              widgetYAxis: false,
            },
          }));
          widgetValidationYAxis = false;
        } else {
          if (
            this.state.widgetName !== "HEAT_MAP" &&
            this.state.widgetName != "MONTE_CARLO"
          ) {
            this.setState((prevState) => ({
              widgetError: {
                ...prevState.widgetError,
                widgetYAxis: true,
              },
            }));
            widgetValidationXAxis = true;
          }
        }
      }
    }

    if (
      widgetValidationName ||
      widgetValidationType ||
      widgetValidationXAxis ||
      widgetValidationYAxis ||
      widgetValidationDashboard ||
      widgetValidationDatasource
    ) {
      return false;
    } else {
      return true;
    }
  };

  getWidgets = async (viewFlag) => {
    try {
      let response = await Api.getWidgetType();
      if (response.status === 200) {
        if (viewFlag === "MITI") {
          var list = response.widgetTypes
            ? response.widgetTypes.filter(
                (item) =>
                  item.name !== "HEAT_MAP" &&
                  item.name != "MONTE_CARLO" &&
                  item.name != "KPI"
              )
            : [];
          this.setState({
            ...this.state,
            widgetTypeList: list,
            widgetTypeListTemp: list,
          });
        } else if (viewFlag === "TASK") {
          var list = response.widgetTypes
            ? response.widgetTypes.filter(
                (item) =>
                  item.name !== "HEAT_MAP" &&
                  item.name !== "MONTE_CARLO" 
              )
            : [];
          this.setState({
            ...this.state,
            widgetTypeList: list,
            widgetTypeListTemp: list,
          });
        } else if (viewFlag === "ACTIVITIES") {
          var list = response.widgetTypes
            ? response.widgetTypes.filter(
                (item) =>
                  item.name !== "HEAT_MAP" &&
                  item.name !== "MONTE_CARLO" &&
                  item.name !== "KPI"
              )
            : [];
          this.setState({
            ...this.state,
            widgetTypeList: list,
            widgetTypeListTemp: list,
          });
        } else {
          let list = response.widgetTypes.filter(
            (item) => item.name !== "BURN_DOWN_CHART"
          );
          this.setState({
            ...this.state,
            widgetTypeList: list,
            widgetTypeListTemp: list,
          });
        }
      } else {
        this.setState({ ...this.state, widgetTypeList: [] });
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, widgetTypeList: [], loader: false });
    }
  };

  selectWidget = (item) => {
    this.setState({
      ...this.state,
      WidgetTypeId: item.widgetTypeId,
      ActiveId: item.widgetTypeId,
      widgetName: item.name,
      XAxisValue: {},
      YAxisValue: {},
    });
    // this.setState({ ...this.state, ActiveId: item.widgetTypeId });
    this.setState((prevState) => ({
      widgetError: {
        ...prevState.widgetError,
        widgetChart: false,
      },
    }));
  };

  saveWidget = async () => {
    if (this.handleValidationWidget()) {
      try {
        this.setState({ ...this.state, loader: true });
        var sDate = this.state.startDate;
        var eDate = this.state.endDate;
        var startDate = sDate
          ? moment(sDate).format("YYYY-MM-DDTHH:mm:ss")
          : undefined;
        var endDate = eDate
          ? moment(eDate).format("YYYY-MM-DDTHH:mm:ss")
          : undefined;

        if (this.state.IsTimestamp && new Date(startDate) > new Date(endDate)) {
          endDate = sDate
            ? moment(sDate).format("YYYY-MM-DDTHH:mm:ss")
            : undefined;
          startDate = eDate
            ? moment(eDate).format("YYYY-MM-DDTHH:mm:ss")
            : undefined;
        }
        if (
          this.state.widgetName == "BURN_DOWN_CHART" &&
          new Date(startDate) > new Date(endDate)
        ) {
          endDate = sDate
            ? moment(sDate).format("YYYY-MM-DDTHH:mm:ss")
            : undefined;
          startDate = eDate
            ? moment(eDate).format("YYYY-MM-DDTHH:mm:ss")
            : undefined;
        }
        let impactId = 0;
        let trendImpactType = null;
        if (this.state.widgetName == "TRENDING_CHART") {
          impactId = this.state.YAxisValue.impactId;
          trendImpactType = this.state.YAxisValue.type;
        }
        var request = {
          widgetId: this.state.widgetId ? this.state.widgetId : undefined,
          Name: this.state.Name,
          WidgetTypeId: this.state.WidgetTypeId,
          DashBoardId: this.state.dashboard.dashboardId,
          DataSource: this.state.datasource ? [this.state.datasource.id] : [0],
          WidgetAxis: {
            XAxisValue: [this.state.XAxisValue],
            YAxisValue:
              this.state.widgetName != "HEAT_MAP" &&
              this.state.widgetName != "MONTE_CARLO"
                ? [this.state.YAxisValue]
                : [],
          },
          CreatedDate: new Date(),
          IsTimestamp: this.state.IsTimestamp,
          isOpportunities: this.state.isOpportunities,
          
          // Add IsDynamicDateRange flag and LastNDays when dynamic date is selected
          IsDynamicDateRange: this.state.dateSelectionType === "dynamic" ? true : false,
          LastNDays: this.state.dateSelectionType === "dynamic" ? this.state.lastNDays : undefined,
          
          // Only set start/end dates when using manual selection
          startDate: this.state.dateSelectionType === "manual" &&
            (this.state.IsTimestamp || this.state.widgetName == "BURN_DOWN_CHART")
              ? startDate
              : undefined,
          endDate: this.state.dateSelectionType === "manual" &&
            (this.state.IsTimestamp || this.state.widgetName == "BURN_DOWN_CHART")
              ? endDate
              : undefined,

          title: this.state.title,
          description: this.state.description,
          CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
          trendFromDate:
            this.state.widgetName == "TRENDING_CHART" ? startDate : undefined,
          trendToDate:
            this.state.widgetName == "TRENDING_CHART" ? endDate : undefined,
          impactId: impactId,
          trendImpactType: trendImpactType,
        };

        let response = await Api.saveWidget(request);
        if (response.status === 200) {
          toastr.success(response.message);
          if (!this.state.widgetId) {
            //create mode
            this.props.refreshDashboard(this.state.dashboard.dashboardId);
          }
          // this.props.selectedDB(this.state.dashboard.dashBoardId);
          this.createWidgetdClose();
          this.setState({ ...this.state, loader: false });
        } else {
          toastr.error(response.message);
          this.setState({ ...this.state, loader: false });
        }
      } catch (error) {
        console.error(error);
        this.setState({ ...this.state, loader: false });
      }
    }
  };

  getYaxisValue = (obj) => {
    var temp = [];
    var yaxis = [];
    try {
      if (this.state.viewFlag == "MITI") {
        if (
          this.state.XAxisValue &&
          Object.keys(this.state.XAxisValue).length != 0
        ) {
          if (this.state.widgetName == "PIE_CHART") {
            if (obj.colsName && obj.colsName == "RiskNumber") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" &&
                  item.colsName != "ActionFieldsCompletion" &&
                  item.colsName != "DaysOverdue" &&
                  item.colsName != "ProjectedDaysOverdue"
              );
            } else if (obj.colsName && obj.colsName == "RiskTitle") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" &&
                  item.colsName != "ActionFieldsCompletion" &&
                  item.colsName != "DaysOverdue" &&
                  item.colsName != "ProjectedDaysOverdue"
              );
            } else if (obj.colsName && obj.colsName == "MitigationName") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" &&
                  item.colsName != "TotalActionCount" &&
                  item.colsName != "OpenActionsCount" &&
                  item.colsName != "ClosedActionsCount" &&
                  item.colsName != "ApprovedOpenActionsCount" &&
                  item.colsName != "UnapprovedOpenActionsCount" &&
                  item.colsName != "ActionFieldsCompletion" &&
                  item.colsName != "OverdueActionCount" &&
                  item.colsName != "ProjectedOverdueActionCount"
              );
            } else if (obj.colsName && obj.colsName == "MitigationNumber") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" &&
                  item.colsName != "TotalActionCount" &&
                  item.colsName != "OpenActionsCount" &&
                  item.colsName != "ClosedActionsCount" &&
                  item.colsName != "ApprovedOpenActionsCount" &&
                  item.colsName != "UnapprovedOpenActionsCount" &&
                  item.colsName != "ActionFieldsCompletion" &&
                  item.colsName != "OverdueActionCount" &&
                  item.colsName != "ProjectedOverdueActionCount"
              );
            } else if (obj.colsName && obj.colsName == "Owner") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" &&
                  item.colsName != "ActionFieldsCompletion" &&
                  item.colsName != "DaysOverdue" &&
                  item.colsName != "ProjectedDaysOverdue"
              );
            } else {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" &&
                  item.colsName != "ActionFieldsCompletion" &&
                  item.colsName != "DaysOverdue" &&
                  item.colsName != "ProjectedDaysOverdue"
              );
            }
          } else if (this.state.widgetName == "BAR_CHART") {
            if (obj.colsName && obj.colsName == "RiskNumber") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" &&
                  item.colsName != "ActionFieldsCompletion" &&
                  item.colsName != "DaysOverdue" &&
                  item.colsName != "ProjectedDaysOverdue"
              );
            } else if (obj.colsName && obj.colsName == "RiskTitle") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" &&
                  item.colsName != "ActionFieldsCompletion" &&
                  item.colsName != "DaysOverdue" &&
                  item.colsName != "ProjectedDaysOverdue"
              );
            } else if (obj.colsName && obj.colsName == "MitigationName") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "TotalActionCount" &&
                  item.colsName != "OpenActionsCount" &&
                  item.colsName != "ClosedActionsCount" &&
                  item.colsName != "ApprovedOpenActionsCount" &&
                  item.colsName != "UnapprovedOpenActionsCount" &&
                  item.colsName != "OverdueActionCount" &&
                  item.colsName != "ProjectedOverdueActionCount"
              );
            } else if (obj.colsName && obj.colsName == "MitigationNumber") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "TotalActionCount" &&
                  item.colsName != "OpenActionsCount" &&
                  item.colsName != "ClosedActionsCount" &&
                  item.colsName != "ApprovedOpenActionsCount" &&
                  item.colsName != "UnapprovedOpenActionsCount" &&
                  item.colsName != "OverdueActionCount" &&
                  item.colsName != "ProjectedOverdueActionCount"
              );
            } else if (obj.colsName && obj.colsName == "Owner") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" &&
                  item.colsName != "DaysOverdue" &&
                  item.colsName != "ProjectedDaysOverdue"
              );
            } else {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" &&
                  item.colsName != "ActionFieldsCompletion" &&
                  item.colsName != "DaysOverdue" &&
                  item.colsName != "ProjectedDaysOverdue"
              );
            }
          } else {
            if (obj.colsName && obj.colsName == "RiskNumber") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" &&
                  item.colsName != "ActionFieldsCompletion" &&
                  item.colsName != "DaysOverdue" &&
                  item.colsName != "ProjectedDaysOverdue"
              );
            } else if (obj.colsName && obj.colsName == "RiskTitle") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" &&
                  item.colsName != "ActionFieldsCompletion" &&
                  item.colsName != "DaysOverdue" &&
                  item.colsName != "ProjectedDaysOverdue"
              );
            } else if (obj.colsName && obj.colsName == "MitigationName") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "TotalActionCount" &&
                  item.colsName != "OpenActionsCount" &&
                  item.colsName != "ClosedActionsCount" &&
                  item.colsName != "ApprovedOpenActionsCount" &&
                  item.colsName != "UnapprovedOpenActionsCount" &&
                  item.colsName != "ActionFieldsCompletion" &&
                  item.colsName != "OverdueActionCount" &&
                  item.colsName != "ProjectedOverdueActionCount"
              );
            } else if (obj.colsName && obj.colsName == "MitigationNumber") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "TotalActionCount" &&
                  item.colsName != "OpenActionsCount" &&
                  item.colsName != "ClosedActionsCount" &&
                  item.colsName != "ApprovedOpenActionsCount" &&
                  item.colsName != "UnapprovedOpenActionsCount" &&
                  item.colsName != "ActionFieldsCompletion" &&
                  item.colsName != "OverdueActionCount" &&
                  item.colsName != "ProjectedOverdueActionCount"
              );
            } else if (obj.colsName && obj.colsName == "Owner") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" &&
                  item.colsName != "ActionFieldsCompletion" &&
                  item.colsName != "DaysOverdue" &&
                  item.colsName != "ProjectedDaysOverdue"
              );
            } else {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" &&
                  item.colsName != "ActionFieldsCompletion" &&
                  item.colsName != "DaysOverdue" &&
                  item.colsName != "ProjectedDaysOverdue"
              );
            }
          }
        }
      } else if (this.state.viewFlag == "RISK") {
        if (
          this.state.XAxisValue &&
          Object.keys(this.state.XAxisValue).length != 0
        ) {
          if (this.state.widgetName == "PIE_CHART") {
            if (obj.colsName && obj.colsName == "RiskNumber") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "Frequency" &&
                  item.colsName != "TotalRiskCount" &&
                  item.colsName != "OpenRiskCount" &&
                  item.colsName != "ClosedRiskCount" &&
                  item.colsName != "PreRiskScore" &&
                  item.colsName != "PreWeightedRiskScore" &&
                  item.colsName != "RiskFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "RiskTitle") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "Frequency" &&
                  item.colsName != "TotalRiskCount" &&
                  item.colsName != "OpenRiskCount" &&
                  item.colsName != "ClosedRiskCount" &&
                  item.colsName != "PreRiskScore" &&
                  item.colsName != "PreWeightedRiskScore" &&
                  item.colsName != "RiskFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "RiskTypeName") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "Frequency" &&
                  item.colsName != "PreRiskScore" &&
                  item.colsName != "PreWeightedRiskScore" &&
                  item.colsName != "RiskFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "UnitName") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "Frequency" &&
                  item.colsName != "PreRiskScore" &&
                  item.colsName != "PreWeightedRiskScore" &&
                  item.colsName != "RiskFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "Owner") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "Frequency" &&
                  item.colsName != "PreRiskScore" &&
                  item.colsName != "PreWeightedRiskScore" &&
                  item.colsName != "RiskFieldsCompletion"
              );
            } else {
              yaxis = this.state.impactWithCountCols;
            }
          }
          if (this.state.widgetName == "BAR_CHART") {
            if (obj.colsName && obj.colsName == "RiskNumber") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "TotalRiskCount" &&
                  item.colsName != "OpenRiskCount" &&
                  item.colsName != "ClosedRiskCount"
              );
            } else if (obj.colsName && obj.colsName == "RiskTitle") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "TotalRiskCount" &&
                  item.colsName != "OpenRiskCount" &&
                  item.colsName != "ClosedRiskCount"
              );
            } else if (obj.colsName && obj.colsName == "RiskTypeName") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) => item.colsName != "Frequency"
              );
            } else if (obj.colsName && obj.colsName == "UnitName") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) => item.colsName != "Frequency"
              );
            } else if (obj.colsName && obj.colsName == "Owner") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) => item.colsName != "Frequency"
              );
            } else {
              if (this.state.widgetName == "HEAT_MAP") {
                yaxis = this.state.heatmapCols;
              } else {
                yaxis = this.state.impactWithCountCols;
              }
            }
          } else if (this.state.widgetName == "LINE_CHART") {
            if (obj.colsName && obj.colsName == "RiskNumber") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "TotalRiskCount" &&
                  item.colsName != "OpenRiskCount" &&
                  item.colsName != "ClosedRiskCount" &&
                  item.colsName != "PreRiskScore" &&
                  item.colsName != "PreWeightedRiskScore" &&
                  item.colsName != "RiskFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "RiskTitle") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "TotalRiskCount" &&
                  item.colsName != "OpenRiskCount" &&
                  item.colsName != "ClosedRiskCount" &&
                  item.colsName != "PreRiskScore" &&
                  item.colsName != "PreWeightedRiskScore" &&
                  item.colsName != "RiskFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "RiskTypeName") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "Frequency" &&
                  item.colsName != "PreRiskScore" &&
                  item.colsName != "PreWeightedRiskScore" &&
                  item.colsName != "RiskFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "UnitName") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "Frequency" &&
                  item.colsName != "PreRiskScore" &&
                  item.colsName != "PreWeightedRiskScore" &&
                  item.colsName != "RiskFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "Owner") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "Frequency" &&
                  item.colsName != "PreRiskScore" &&
                  item.colsName != "PreWeightedRiskScore" &&
                  item.colsName != "RiskFieldsCompletion"
              );
            } else {
              if (this.state.widgetName == "HEAT_MAP") {
                yaxis = this.state.heatmapCols;
              } else {
                yaxis = this.state.impactWithCountCols;
              }
            }
          } else {
            if (obj.colsName && obj.colsName == "RiskNumber") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "TotalRiskCount" &&
                  item.colsName != "OpenRiskCount" &&
                  item.colsName != "ClosedRiskCount" &&
                  item.colsName != "RiskFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "RiskTitle") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "TotalRiskCount" &&
                  item.colsName != "OpenRiskCount" &&
                  item.colsName != "ClosedRiskCount" &&
                  item.colsName != "RiskFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "RiskTypeName") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "Frequency" &&
                  item.colsName != "RiskFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "UnitName") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "Frequency" &&
                  item.colsName != "RiskFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "Owner") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "Frequency" &&
                  item.colsName != "RiskFieldsCompletion"
              );
            } else {
              if (this.state.widgetName == "HEAT_MAP") {
                yaxis = this.state.heatmapCols;
              } else {
                yaxis = this.state.impactWithCountCols;
              }
            }
          }
        }
      } else if (
        this.state.viewFlag == "TASK" ||
        this.state.viewFlag == "ACTIVITIES"
      ) {
        if (obj.colsName == "OwnerName") {
          yaxis = this.state.yAxisColumnsList.filter(
            (item) =>
              item.colsName != "PercentageOnTrack" &&
              item.colsName != "PercentageCompletion" &&
              item.colsName != "DaysOverdue" &&
              item.colsName != "ProjectedDaysOverdue"
          );
        }else if(obj.colsName == "TaskNumber" || obj.colsName == "TaskTitle"){
          yaxis = this.state.yAxisColumnsList.filter(
            (item) =>
              item.colsName != "OpenTaskCount" &&
              item.colsName != "ClosedTaskCount" &&
              item.colsName != "ApprovedTaskCount" &&
              item.colsName != "UnApprovedTaskCount"&&
              item.colsName != "OverdueTaskCount" &&
              item.colsName != "ProjectedOverdueTaskCount"
          );
        }
        else if(obj.colsName == "TaskActionNumber" || obj.colsName == "TaskActionTitle"){
          yaxis = this.state.yAxisColumnsList.filter(
            (item) =>
              item.colsName != "TotalActivityCount" &&
              item.colsName != "OpenActivityCount" &&
              item.colsName != "ClosedActivityCount" &&
              item.colsName != "ApprovedActivityCount"&&
              item.colsName != "UnApprovedActivityCount" &&
              item.colsName != "OverdueActivityCount" &&
              item.colsName != "ProjectedOverdueActivityCount"
          );
        } else {
          // yaxis = this.state.yAxisColumnsList;
          yaxis = this.state.yAxisColumnsList.filter(
            (item) =>
              item.colsName != "DaysOverdue" &&
              item.colsName != "ProjectedDaysOverdue"
          );
        }
      }
      if (this.state.widgetName === "TRENDING_CHART") {
        temp = this.state.trendYAxis;
      } else if (this.state.widgetName !== "HEAT_MAP") {
        temp = yaxis.filter((item) => item.displayName !== "All Impacts");
      } else {
        temp = yaxis;
      }

      if (this.state.IsTimestamp === true) {
        temp = temp.filter(
          (item) =>
            item.colsName != "ActionFieldsCompletion" &&
            item.colsName != "RiskFieldsCompletion"
        );
      }
    } catch (error) {}
    return temp;
  };

  isExistName = async (e) => {
    try {
      if (e.target.value == "") {
        return;
      }
      let request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        Name: e.target.value,
      };
      let response = await Api.widgetDuplicationCheck(request);
      if (response.status === 200) {
        this.setState({ ...this.state, isNameExist: false });
      } else {
        this.setState({
          ...this.state,
          isNameExist: true,
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
  selectDataset = async (e) => {
    this.setState({
      ...this.state,
      datasource: e.target.value,
    });
    if (e.target.value) {
      this.setState((prevState) => ({
        widgetError: {
          ...prevState.widgetError,
          widgetDataSet: false,
        },
      }));
    } else {
      this.setState((prevState) => ({
        widgetError: {
          ...prevState.widgetError,
          widgetDataSet: true,
        },
      }));
    }
    await this.getAxisFromDataset(e.target.value);
  };

  getAxisFromDataset = (ds) => {
    let heatmapCols = ds.yAxis
      ? ds.yAxis.filter(
          (item) =>
            item.colsName != "PreWeightedRiskScore" &&
            item.colsName != "PreRiskScore" &&
            item.colsName != "OpenRiskCount" &&
            item.colsName != "TotalRiskCount" &&
            item.colsName != "ClosedRiskCount"
        )
      : [];

    if (this.state.viewFlag === "RISK") {
      this.setState({
        ...this.state,
        xAxisColumnsList: ds.xAxis
          ? [...this.state.xAxisColumnsListTemp, ...ds.xAxis]
          : this.state.xAxisColumnsListTemp,
        yAxisColumnsList: ds.yAxis
          ? [...this.state.yAxisColumnsListTemp, ...ds.yAxis]
          : this.state.yAxisColumnsListTemp,
        timestampXAxisColumns: ds.xAxis
          ? [...this.state.xAxisColumnsListTemp, ...ds.xAxis]
          : this.state.xAxisColumnsListTemp,
        timestampYAxisColumns: ds.yAxis
          ? [...this.state.yAxisColumnsListTemp, ...ds.yAxis]
          : this.state.yAxisColumnsListTemp,
        heatmapCols: heatmapCols,
        impactWithCountCols: ds.yAxis,
        datasource: ds,
        trendYAxis: ds.trendYAxis,
      });
    } else {
      this.setState({
        ...this.state,
        xAxisColumnsList: ds.xAxis
          ? [...this.state.xAxisColumnsListTemp, ...ds.xAxis]
          : this.state.xAxisColumnsListTemp,
        // xAxisColumnsList: this.state.xAxisColumnsListTemp?this.state.xAxisColumnsListTemp:[],
        yAxisColumnsList: ds.yAxis
          ? [...this.state.yAxisColumnsListTemp, ...ds.yAxis]
          : this.state.yAxisColumnsListTemp,
        timestampXAxisColumns: this.state.xAxisColumnsListTemp
          ? this.state.xAxisColumnsListTemp
          : [],
        timestampYAxisColumns: ds.yAxis
          ? [...this.state.yAxisColumnsListTemp, ...ds.yAxis]
          : this.state.yAxisColumnsListTemp,
        heatmapCols: heatmapCols,
        impactWithCountCols: ds.yAxis,
        datasource: ds,
        trendYAxis: ds.trendYAxis,
      });
    }
  };

  getImpactListValues = () => {
    var temp = [];
    try {
      var tempList =
        this.state.widgetName == "HEAT_MAP" ||
        this.state.widgetName == "MONTE_CARLO"
          ? this.state.widgetName === "MONTE_CARLO"
            ? this.state.heatmapCols.filter(
                (item) => !item.colsName.startsWith("QImpact$$")
              )
            : this.state.heatmapCols
          : this.state.xAxisColumnsList;

      if (this.state.widgetName !== "HEAT_MAP") {
        temp = tempList.filter((item) => item.displayName !== "All Impacts");
      } else {
        temp = tempList;
      }
    } catch (error) {}
    return temp;
  };

  render() {
    return (
      <div>
        <Popup
          show={this.state.openWidgetCreatePopup}
          popupClass={"popup-content"}
        >
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="reportsPopup">
            <h3>
              {this.state.viewFlag === "MITI"
                ? "Create Action Report"
                : this.state.viewFlag === "RISK"
                ? "Create Risk Report"
                : this.state.viewFlag === "TASK"
                ? "Create Task Report"
                : "Create Activities Report"}
            </h3>
            <div className="formControl">
              <label>Report Name * </label>
              <input
                type="text"
                value={this.state.Name}
                onBlur={(e) => this.isExistName(e)}
                onChange={(e) => {
                  this.setState({
                    ...this.state,
                    Name: e.target.value,
                  });
                  if (e.target.value) {
                    this.setState((prevState) => ({
                      widgetError: {
                        ...prevState.widgetError,
                        widgetName: false,
                      },
                    }));
                  } else {
                    this.setState((prevState) => ({
                      widgetError: {
                        ...prevState.widgetError,
                        widgetName: true,
                      },
                    }));
                  }
                }}
              />
              {this.state.widgetError && this.state.widgetError.widgetName ? (
                <span className="errMsg">Report name is required</span>
              ) : (
                ""
              )}
              {this.state.isNameExist && (
                <span className="errMsg">Duplicate Report Name</span>
              )}
            </div>
            {this.state.widgetName != "BURN_DOWN_CHART" &&
            this.state.widgetName != "MONTE_CARLO" &&
            this.state.widgetName !== "TEXT_WIDGET" &&
            this.state.widgetName !== "KPI" &&
            this.state.widgetName !== "DATA" &&
            this.state.viewFlag !== "TASK" &&
            this.state.viewFlag !== "ACTIVITIES" ? (
              <div className="formControl">
                {this.state.widgetName !== "TRENDING_CHART" && (
                  <Checkbox
                    defaultValue={this.state.IsTimestamp}
                    label={"Timestamp"}
                    onChange={this.ToggleTimestamp}
                  />
                )}

                <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                {
                  <Checkbox
                    defaultValue={this.state.isOpportunities}
                    label={"Opportunities"}
                    onChange={(e) => {
                      this.setState({
                        ...this.state,
                        isOpportunities: e.value,
                      });
                    }}
                  />
                }
              </div>
            ) : (
              ""
            )}
            <div className="chartBox formControl">
              <label>Select Chart *</label>
              <ul className={this.state.ActiveId != null ? "selected" : ""}>
                {this.state.widgetTypeList &&
                  this.state.widgetTypeList.map((item) => (
                    <li
                      onClick={() => this.selectWidget(item)}
                      className={
                        item.widgetTypeId === this.state.ActiveId
                          ? "active"
                          : ""
                      }
                    >
                      <a className="gBox active">
                        <img
                          src={this.getChatImage(item.image)}
                          height="40"
                          alt="Chart"
                        />
                        <span>
                          {item.displayname === "Kpi"
                            ? item.displayname.toLocaleUpperCase()
                            : item.displayname}
                        </span>
                      </a>
                    </li>
                  ))}
              </ul>
              {this.state.widgetError && this.state.widgetError.widgetChart ? (
                <span className="errMsg">Chart is required</span>
              ) : (
                ""
              )}
            </div>
            <div className="formControl">
              <label>Report Title</label>
              <input
                value={this.state.title}
                type="text"
                onChange={(e) => {
                  this.setState({
                    ...this.state,
                    title: e.target.value,
                  });
                }}
              />
            </div>
            <div className="formControl">
              <label>Report Description</label>
              <input
                value={this.state.description}
                type="text"
                onChange={(e) => {
                  this.setState({
                    ...this.state,
                    description: e.target.value,
                  });
                }}
              />
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12">
                <div class="formControl">
                  <label>Select Dashboard *</label>
                  <div className="dBlockCont">
                    <DropDownList
                      data={this.state.dashboardList}
                      onChange={(e) => {
                        this.setState({
                          ...this.state,
                          dashboard: e.target.value,
                        });
                        if (e.target.value) {
                          this.setState((prevState) => ({
                            widgetError: {
                              ...prevState.widgetError,
                              widgetDashboard: false,
                            },
                          }));
                        } else {
                          this.setState((prevState) => ({
                            widgetError: {
                              ...prevState.widgetError,
                              widgetDashboard: true,
                            },
                          }));
                        }
                      }}
                      value={this.state.dashboard}
                      textField="name"
                    />
                  </div>
                  {this.state.widgetError &&
                  this.state.widgetError.widgetDashboard ? (
                    <span className="errMsg">Dashboard is required</span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {this.state.widgetName !== "TEXT_WIDGET" && (
                <div className="col-xs-12 col-sm-12 col-md-12">
                  <div class="formControl">
                    <label>{/* Select View */}Dataset *</label>
                    <div className="dBlockCont">
                      <DropDownList
                        data={this.state.datasourceList}
                        onChange={(e) => this.selectDataset(e)}
                        value={this.state.datasource}
                        textField="name"
                      />
                    </div>
                    {this.state.widgetError &&
                    this.state.widgetError.widgetDataSet ? (
                      <span className="errMsg">Data Set is required</span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              )}

              {this.state.widgetName !== "BURN_DOWN_CHART" &&
              this.state.widgetName !== "TEXT_WIDGET" &&
              this.state.widgetName !== "KPI" &&
              this.state.widgetName !== "DATA" ? (
                <>
                  {this.state.widgetName !== "TRENDING_CHART" && (
                    <div className="col-xs-12 col-sm-12 col-md-12">
                      <div class="formControl">
                        {this.state.widgetName == "BAR_CHART" ||
                        this.state.widgetName == "LINE_CHART" ? (
                          <label>
                            X Axis *<small></small>
                          </label>
                        ) : this.state.widgetName == "HEAT_MAP" ||
                          this.state.widgetName == "MONTE_CARLO" ? (
                          <label>
                            Select Impact *<small></small>
                          </label>
                        ) : (
                          <label>
                            Categories *<small></small>
                          </label>
                        )}
                        <div className="dBlockCont">
                          <DropDownList
                            data={this.getImpactListValues()}
                            value={this.state.XAxisValue}
                            disabled={
                              !this.state.widgetName || !this.state.datasource
                            }
                            textField="displayName"
                            onChange={(e) => {
                              this.setState({
                                ...this.state,
                                XAxisValue: e.target.value,
                                YAxisValue: {},
                              });
                              if (e.target.value) {
                                this.setState((prevState) => ({
                                  widgetError: {
                                    ...prevState.widgetError,
                                    widgetXAxis: false,
                                  },
                                }));
                              } else {
                                this.setState((prevState) => ({
                                  widgetError: {
                                    ...prevState.widgetError,
                                    widgetXAxis: true,
                                  },
                                }));
                              }
                            }}
                          />
                        </div>
                        {this.state.widgetError &&
                        this.state.widgetError.widgetXAxis ? (
                          <span className="errMsg">X-Axis is required</span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  )}

                  <div className="col-xs-12 col-sm-12 col-md-12">
                    <div class="formControl">
                      {this.state.widgetName == "BAR_CHART" ||
                      this.state.widgetName == "LINE_CHART" ||
                      this.state.widgetName === "TRENDING_CHART" ? (
                        <label>
                          Y Axis *<small></small>
                        </label>
                      ) : this.state.widgetName == "HEAT_MAP" ||
                        this.state.widgetName == "MONTE_CARLO" ? (
                        ""
                      ) : (
                        <label>
                          Value *<small></small>
                        </label>
                      )}
                      {this.state.widgetName != "HEAT_MAP" &&
                      this.state.widgetName != "MONTE_CARLO" ? (
                        <div className="dBlockCont">
                          <DropDownList
                            data={this.getYaxisValue(this.state.XAxisValue)}
                            value={this.state.YAxisValue}
                            textField="displayName"
                            disabled={
                              this.state.widgetName !== "TRENDING_CHART"
                                ? !this.state.XAxisValue ||
                                  Object.keys(this.state.XAxisValue).length == 0
                                : !this.state.widgetName ||
                                  !this.state.datasource
                            }
                            onChange={(e) => {
                              this.setState({
                                ...this.state,
                                YAxisValue: e.target.value,
                              });
                              if (e.target.value) {
                                this.setState((prevState) => ({
                                  widgetError: {
                                    ...prevState.widgetError,
                                    widgetYAxis: false,
                                  },
                                }));
                              } else {
                                this.setState((prevState) => ({
                                  widgetError: {
                                    ...prevState.widgetError,
                                    widgetYAxis: true,
                                  },
                                }));
                              }
                            }}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      {this.state.widgetError &&
                      this.state.widgetError.widgetYAxis ? (
                        <span className="errMsg">Y-Axis is required</span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}

              {this.state.IsTimestamp === true ||
              this.state.widgetName === "TRENDING_CHART" ||
              (this.state.widgetName === "BURN_DOWN_CHART" &&
                this.state.widgetName !== "TEXT_WIDGET" &&
                this.state.widgetName !== "KPI" &&
                this.state.widgetName !== "DATA") ? (
                <div className="col-xs-12 col-sm-12 col-md-12">
                  <div className="formControl">
                    <div className="TimestampHeader">
                      {/* Radio button selection for date type - positioned at the top */}
                      <div className="dateSelectionType" style={{ marginBottom: '15px', display: 'block', width: '100%' }}>
                        <div style={{ marginBottom: '15px' }}>
                          <div style={{ display: 'flex', marginBottom: '10px' }}>
                            <div style={{ marginRight: '20px' }}>
                              <input
                                type="radio"
                                id="manualDates"
                                name="dateSelectionType"
                                value="manual"
                                checked={this.state.dateSelectionType === "manual"}
                                onChange={() => {
                                  this.setState({
                                    ...this.state,
                                    dateSelectionType: "manual"
                                  });
                                }}
                                style={{ marginRight: '5px' }}
                              />
                              <label htmlFor="manualDates">
                                {this.state.IsTimestamp ? "Manual Snapshots" : "Manual Date Range"}
                              </label>
                            </div>
                            
                            <div>
                              <input
                                type="radio"
                                id="dynamicDates"
                                name="dateSelectionType"
                                value="dynamic"
                                checked={this.state.dateSelectionType === "dynamic"}
                                onChange={() => {
                                  this.setState({
                                    ...this.state,
                                    dateSelectionType: "dynamic"
                                  });
                                }}
                                style={{ marginRight: '5px' }}
                              />
                              <label htmlFor="dynamicDates">Number Of Days</label>
                            </div>
                          </div>
                        </div>
                        
                        {/* Last N days input field - only shown when dynamic option is selected */}
                        {this.state.dateSelectionType === "dynamic" && (
                          <div className="lastNDaysInput" style={{ marginBottom: '15px' }}>
                            <label htmlFor="lastNDays" style={{ display: 'block', marginBottom: '5px' }}>
                              Number of days:
                            </label>
                            <input
                              id="lastNDays"
                              type="number"
                              min="0"
                              value={this.state.lastNDays}
                              onChange={(e) => {
                                const value = parseInt(e.target.value) || 1;
                                this.setState({
                                  ...this.state,
                                  lastNDays: value
                                });
                              }}
                              style={{
                                backgroundColor: "#1e1e1e",
                                color: "white",
                                border: "1px solid #444",
                                borderRadius: "4px",
                                padding: "8px",
                                width: "50%",
                                maxWidth: '200px'
                              }}
                            />
                          </div>
                        )}
                      </div>
                      
                      {/* Only show date pickers when manual option is selected */}
                      {this.state.dateSelectionType === "manual" && (
                        <ul>
                        <li>
                          {this.state.IsTimestamp == true ? (
                            <label>Snapshot 1 *</label>
                          ) : (
                            <label>Start Date *</label>
                          )}
                          {this.state.widgetName === "TRENDING_CHART" ? (
                            <DatePicker
                              max={new Date()}
                              format="dd-MMM-yyyy"
                              defaultValue={this.state.startDate}
                              formatPlaceholder="Snapchat11"
                              onChange={(e) => {
                                this.setState({
                                  ...this.state,
                                  startDate: e.target.value,
                                });
                              }}
                            />
                          ) : (
                            <DatePicker
                              // max={new Date()}
                              format="dd-MMM-yyyy"
                              defaultValue={this.state.startDate}
                              formatPlaceholder="Snapchat11"
                              onChange={(e) => {
                                this.setState({
                                  ...this.state,
                                  startDate: e.target.value,
                                });
                              }}
                            />
                          )}
                        </li>
                        <li>
                          {this.state.IsTimestamp == true ? (
                            <label>Snapshot 2 *</label>
                          ) : (
                            <label>End Date *</label>
                          )}
                          {this.state.widgetName === "TRENDING_CHART" ? (
                            <DatePicker
                              max={new Date()}
                              min={
                                this.state.startDate
                                  ? this.state.startDate
                                  : new Date()
                              }
                              format="dd-MMM-yyyy"
                              formatPlaceholder="Snapchat2"
                              defaultValue={this.state.endDate}
                              onChange={(e) => {
                                this.setState({
                                  ...this.state,
                                  endDate: e.target.value,
                                });
                              }}
                            />
                          ) : (
                            <DatePicker
                              // max={new Date()}
                              // min={this.state.startDate?this.state.startDate:new Date()}
                              format="dd-MMM-yyyy"
                              formatPlaceholder="Snapchat2"
                              defaultValue={this.state.endDate}
                              onChange={(e) => {
                                this.setState({
                                  ...this.state,
                                  endDate: e.target.value,
                                });
                              }}
                            />
                          )}
                        </li>
                      </ul>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="d-flex justify-content-end">
              <button
                className="btnGreen"
                type="button"
                onClick={this.saveWidget}
              >
                {"Create Report"}
              </button>
              <button
                className="btnRed"
                type="button"
                onClick={this.createWidgetdClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>
      </div>
    );
  }
}
